import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    assets: 'Assets',
    protocol: 'Protocol',
    network: 'Network',
    actions: 'Actions',
  },
};
